module.exports = __webpack_public_path__ + "img/help1.90a58cd2.png";